import { createReduxModule } from "hooks-for-redux";
import { USE_PROD } from "../services/api";
import { getConfiguredHost, getServiceHost } from "../services/runtimeHost";

const initialState = {
  ws: null,
  websocketUrl: null,
  longPollingUrl: null,
  reconnectStart: null,
  reconnectTime: null,
  pingTime: 0,
  pingReceived: true,
  pingStart: Date.now(),
  otherLoginShow: false,
  otherLoginSameBrowser: false,
  wsConnected: false,
  connectionBlockedReason: null,
};

const testPorts = {
  ws1: "9090",
  ws2: "9091",
  ws3: "9092",
};

export const [
  useWsConnection,
  {
    setWebsocketUrl,
    doStartReconnectTimer,
    updateReconnectTimer,
    endReconnectTimer,
    setOtherLoginShow,
    setOtherLoginSameBrowser,
    setWsConnected,
    setConnectionBlockedReason,
  },
  wsConnectionStore,
] = createReduxModule("wsConnection", initialState, {
  setWebsocketUrl: (state, ws) => {
    const serverInstance = "ws" + ws;
    const testPort = testPorts[serverInstance];
    const host = USE_PROD ? getServiceHost() : getConfiguredHost();
    const websocketUrl = USE_PROD
      ? `wss://${host}/${serverInstance}/`
      : `ws://${host}:${testPort}`;

    const longPollingUrl = USE_PROD
      ? `https://${host}/${serverInstance}/api`
      : `http://${host}:${testPort}/${serverInstance}/api`;

    return {
      ...state,
      ws,
      websocketUrl,
      longPollingUrl,
    };
  },
  doStartReconnectTimer: (state) => ({
    ...state,
    reconnectStart: Date.now(),
  }),
  updateReconnectTimer: (state) => ({
    ...state,
    reconnectTime: Date.now(),
  }),
  endReconnectTimer: (state) => ({
    ...state,
    reconnectStart: null,
    reconnectTime: null,
  }),
  setOtherLoginShow: (state, otherLoginShow) => ({
    ...state,
    otherLoginShow,
  }),
  setOtherLoginSameBrowser: (state, otherLoginSameBrowser) => ({
    ...state,
    otherLoginSameBrowser,
  }),
  setWsConnected: (state, wsConnected) => ({
    ...state,
    wsConnected,
  }),
  setConnectionBlockedReason: (state, connectionBlockedReason) => ({
    ...state,
    connectionBlockedReason,
  }),
});
